//import { getToken } from '../Utils/Common';

import {getToken} from "../Utils/Common";

//let apilink = "https://d25c1smh4gyzd4.cloudfront.net/"
let apilink = process.env.REACT_APP_BACKEND_API_URI

export function getKategoriesDataAPI() {
        let data = {
        token:getToken(),
        collection_name: 'PositionCategory'
    };

    return fetch(`${apilink}parser/parseopen`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            //Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify(data)
    })
        .then((response) => response.json())
        .then((data) => data.data)
}

export function addKategoriesDataAPI(newKategorieID, newKategorieName) {
    let data = {
        id: newKategorieID,
        collection_name: 'PositionCategory',
        data: {
            category: newKategorieName
        },
        token:getToken()

    };

    return fetch(`${apilink}parser/createpcategory`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            //Authorization: 'Bearer ' + getToken()
        },
        body: JSON.stringify(data)
    });
}

export function updateKategoriesDataAPI(id, updateKategorieName) {
    let data = {
        id: id,
        collection_name: 'PositionCategory',
        new_category_name: updateKategorieName,
        token:getToken()
    };

    return fetch(`${apilink}parser/updatepcategory`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}

export function deleteCategoryAPI(id) {
    let data = {
        id: id,
        collection_name: 'PositionCategory',
        token: getToken()
    };

    return fetch(`${apilink}parser/deletepcategory`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
}

export function downloadDatasetAPI() {
    let data = {
        token: getToken()
    };
    return fetch(`${apilink}parser/download_dataset`, {
    //return fetch('http://testapi.eba-qpsrxpqx.eu-central-1.elasticbeanstalk.com/parser/download_dataset', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
}

// export function updateIndividualKategoriesDataAPI(categoryData) {
//
//     return fetch(`${apilink}/parser/updateindividualcategory`, {
//         method: 'PUT',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(categoryData)
//     });
// }

export function updateIndividualKategoriesDataAPI(categoryData) {
categoryData.token=getToken()
    return fetch(`${apilink}parser/updateindividualcategory`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(categoryData)
    });
}

export function addPositionToDatasetAPI(o, lv_id) {
    let data = {
        pos: o,
        lv_id: lv_id,
        token: getToken()
    }
    return fetch(`${apilink}parser/add_position_to_dataset`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}

export function removePositionFromDatasetAPI(o, lv_id) {
    let data = {
        row_id: o.row_id,
        lv_id: lv_id,
        token: getToken()
    }
    return fetch(`${apilink}parser/remove_position_from_dataset`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}

export function addPositionToAnnotationsTrainingAPI(row_id) {
    let data = {
        row_id: row_id,
        token: getToken()
    }
    return fetch(`${apilink}annotator/add_to_annotations_training_data`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}

export function addPositionToAnnotationsTrainingExclusionsAPI(row_id) {
    let data = {
        row_id: row_id,
        token: getToken()
    }
    return fetch(`${apilink}annotator/add_to_annotations_excluded_data`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
}


// export function getKategoriesDataAPI() {
//     let data = {
//         collection_name: 'positioncategory'
//     };
//
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/category/read`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             Authorization: 'Bearer ' + getToken()
//         },
//         body: JSON.stringify(data)
//     })
//         .then((response) => response.json())
//         .then((data) => data);
// }
//
// export function addKategoriesDataAPI(newKategorieID, newKategorieName) {
//     let data = {
//         id: newKategorieID,
//         collection_name: 'positioncategory',
//         data: {
//             category: newKategorieName
//         }
//     };
//
//     return fetch(`${process.env.REACT_APP_BASE_URI}/api/category/create`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             Authorization: 'Bearer ' + getToken()
//         },
//         body: JSON.stringify(data)
//     });
// }
//
// export function updateKategoriesDataAPI(id, updateKategorieName) {
//     let data = {
//         id: id,
//         collection_name: 'positioncategory',
//         data: {
//             name: updateKategorieName
//         }
//     };
//
//     return fetch(`${process.env.REACT_APP_POSITION_CATEGORY_ENDPOINT}/kategories/` + id, {
//         method: 'PUT',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(data)
//     });
// }
